import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AppComponent } from '../app.component';
import { DataserviceService } from '../dataservice.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-pins-by-provider',
  templateUrl: './pins-by-provider.component.html',
  styleUrl: './pins-by-provider.component.css'
})
export class PinsByProviderComponent {

  currentUser: any;
  addForm: FormGroup;
  providers: any[] = [];
  providersLoading: boolean = false;
  users: any[] = [];
  usersList: any[] = [];
  usersLoading: boolean = false;
  submitting: boolean = false;

  constructor(
    private app: AppComponent,
    private data: DataserviceService,
    private nzNotify: NzNotificationService
  ) {
    this.addForm = new FormGroup({
      userId: new FormControl(null, [Validators.required]),
      providerId: new FormControl(null, [Validators.required])
    })
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('user')!);
    this.getUsers();
    this.getProviders();
  }

  getUsers() {
    this.usersLoading = true;
    let params = this.setParams();

    this.data.getData(`users/users-list`, { params })
      .subscribe({
        next: (res: any) => {
          const users = res || [];
          this.users = users.filter((user: any) => !!user?.user_id);
          this.usersList = [...this.users];
          this.usersLoading = false;
        },
        error: () => {
          this.usersLoading = false;
          this.errorNotification('Failed to load users');
        }
      })
  }

  getProviders() {
    this.providersLoading = true;
    this.data.getData('providers')
      .subscribe({
        next: (res: any) => {
          this.providers = res?.data || [];
          this.providersLoading = false;
        },
        error: () => {
          this.providersLoading = false;
          this.errorNotification('Failed to load providers');
        }
      })
  }

  setParams() {
    let params = new HttpParams()

    if (this.hasPermission('view_all_users')) {
      params = params.set('all', true);
    }
    else if (this.hasPermission('view_distributor_users')) {
      params = params.set('distributor_id', this.currentUser.distributor_id);
    }
    else if (this.hasPermission('view_company_users')) {
      params = params.set('company_id', this.currentUser.company_id);
    }
    else if (this.currentUser?.viewable_groups?.length > 0) {
      params = params.set('viewable_groups', this.currentUser.viewable_groups);
    }
    else {
      params = params.set('my_id', this.currentUser.id);
    }

    return params;
  }

  hasPermission(permission: string): boolean {
    return this.app.hasPermission(permission);
  }

  searchUsers(value: string) {
    if (!value) {
      this.usersList = [...this.users];
      return;
    }

    const term = value.toLowerCase();
    this.usersList = this.users.filter((user: any) => {
      const fullName = `${user?.first_name || ''} ${user?.last_name || ''}`.trim().toLowerCase();
      const email = user?.email?.toLowerCase() || '';
      const crmId = user?.user_id?.toLowerCase() || '';

      return (
        fullName.includes(term) ||
        email.includes(term) ||
        crmId.includes(term)
      );
    });
  }

  submit() {
    if (this.addForm.invalid) {
      this.addForm.markAllAsTouched();
      return;
    }

    this.submitting = true;

    const payload = {
      user_crm: this.addForm.get('userId')?.value,
      provider_id: this.addForm.get('providerId')?.value
    };

    this.data.postData(payload, `pins/pins-by-provider`)
      .subscribe({
        next: () => {
          this.successNotification('User was added to provider access list');
          this.addForm.reset();
          this.submitting = false;
        },
        error: () => {
          this.errorNotification('Failed to add user to provider access list');
          this.submitting = false;
        }
      })
  }

  successNotification(str: string) {
    this.nzNotify.create(
      'success',
      'Success!',
      str,
      { nzPlacement: 'top' }
    );
  }

  errorNotification(str: string) {
    this.nzNotify.create(
      'error',
      'Error!',
      str,
      { nzPlacement: 'top' }
    );
  }
}
